import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

const document = graphql(`
  mutation StrategyMemoListPage_CloneStrategyMemo($strategyMemoId: ID!) {
    copyCustomerStrategyMemo(id: $strategyMemoId) {
      id
    }
  }
`)

export const useCloneStrategyMemoMutation = (
  options: MutationOptions<string, string> = {},
) => {
  const { t } = useTranslation()
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: async (strategyMemoId) => {
      const result = await graphQLRequest({
        document,
        variables: { strategyMemoId },
      })
      const clonedStrategyMemoId = result.copyCustomerStrategyMemo?.id
      if (!exists(clonedStrategyMemoId)) {
        throw new Error(t('duplication_failed_3'))
      }

      return clonedStrategyMemoId
    },
    ...options,
  })
}
